__turbopack_context__.v({
  "address": "PostalEntrySlidingModal-module__JpgUfq__address",
  "heading": "PostalEntrySlidingModal-module__JpgUfq__heading",
  "paragraph": "PostalEntrySlidingModal-module__JpgUfq__paragraph",
});
